import styled from "styled-components";

export const MapControlContainer = styled.div<{ width?: string; withPadding?: boolean }>`
  height: 100%;
  width: ${({ width }) => width || "auto"};
  display: flex;
  padding-left: ${({ withPadding }) => (withPadding ? ".25rem" : "0")};
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  flex-direction: row;
  align-items: center;
  background: ${({ theme: { palette } }) => palette.background};
  margin-right: 0.5rem;
  z-index: 4;
`;
